module.exports = __webpack_public_path__ + "static/media/trophy.73df1375.svg";